import {load} from '@cashfreepayments/cashfree-js';
export const cashfree = await load({
	mode: "production" //"sandbox" //or 
}); 